import React from 'react'
import Container from '../../components/Container'

const NotFound = () => <Container>The page dosen't exist</Container>

export default NotFound
